'use client';

/* eslint-disable @next/next/no-img-element */
import { StaticImageData } from 'next/image';
import { forwardRef, ImgHTMLAttributes, useEffect, useState } from 'react';
import { isImageStatic, newUrl } from './utils';

export type TSize = 'sm' | 'md' | 'lg';

interface IProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'ref'> {
  src: string | StaticImageData | null | any;
  alt: string;
  height: number;
  width: number;
  thumbnail?: boolean;
  size?: TSize;
}

export const ImageModify = forwardRef<HTMLImageElement, IProps>(
  //пропсы к картинке
  function ImageModify(props, ref) {
    const {
      alt,
      src,
      height,
      width,
      thumbnail = true,
      size = 'lg',
      ...otherProps
    } = props;
    const ff = src;

    //создаем ссылку на картинку через useState
    const [urlImg, setUrlImage] = useState<string>('');

    const handleError = () => {
      setUrlImage(src); // Замени url на src по умолчанию при ошибке
    };

    useEffect(() => {
      //проверяем что бы переданный путь src был строкой
      if (isImageStatic(src)) {
        //проверяем есть ли thumbnail
        if (thumbnail) {
          const img = document.createElement('img'); //создаем тег картинки
          img.src = newUrl(src, size); //создаем юрл для миниатюры
          img.onerror = () => {
            setUrlImage(src);
          }; //если миниатюра не загрузилась ставим ориг картинку в юрл
          img.onload = () => setUrlImage(img.src); //если миниатюра загрузилась ставим миниатюру в юрл
        } else {
          setUrlImage(src); //если нет ставим оригинальную картинку в юрл
        }
      } else {
        setUrlImage(src?.src); //если переданный путь src был объектом ставим src в юрл
      }
    }, [src]);

    return (
      <>
        {urlImg === '' ? (
          <div style={{ height, width }} /> //если картинки нет создаем пустой див размера картинки из пропсов
        ) : (
          <img //если юрл есть то создаем картинку используя параметры из пропсов и ссылку, полученную в useEffect
            ref={ref}
            {...otherProps}
            alt={alt}
            src={urlImg}
            onError={handleError}
          />
        )}
      </>
    );
  },
);
